// Utilidad para manejar datos de usuario de Google desde localStorage

export interface GoogleUserData {
  full_name?: string;
  avatar_url?: string;
  given_name?: string;
  family_name?: string;
  email?: string;
}

export const getGoogleUserData = (): GoogleUserData | null => {
  try {
    const stored = localStorage.getItem('google_user_data');
    if (stored) {
      const data = JSON.parse(stored);
      console.log('getGoogleUserData - Datos encontrados:', data);
      return data;
    }
  } catch (error) {
    console.error('Error al obtener datos de Google desde localStorage:', error);
  }
  return null;
};

export const setGoogleUserData = (data: GoogleUserData): void => {
  try {
    localStorage.setItem('google_user_data', JSON.stringify(data));
    console.log('setGoogleUserData - Datos guardados:', data);
  } catch (error) {
    console.error('Error al guardar datos de Google en localStorage:', error);
  }
};

export const clearGoogleUserData = (): void => {
  try {
    localStorage.removeItem('google_user_data');
    console.log('clearGoogleUserData - Datos eliminados');
  } catch (error) {
    console.error('Error al eliminar datos de Google del localStorage:', error);
  }
};
